// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1920":"f835dc6d","2211":"590e8d7b","2262":"7a01a02e","2459":"d93e5d1f","4850":"7a01a02e"}[chunkId] + ".chunk.css";
};